<!--
  SectionHeader.vue

  Per the 2026-05-29 distributor-account design handoff (section header
  pattern used on every page of the redesign). Eyebrow + title + lede,
  plus an optional actions slot on the trailing edge of the title row.

  See planning/design-handoffs/handoff_2026-05-09/2026-05-29-distributor-account/
  design/distributor-sections.jsx for the source pattern.
-->
<template>
    <header class="dist-section-header" data-testid="dist-section-header">
        <div v-if="eyebrow" class="dist-section-header__eyebrow">
            {{ eyebrow }}
        </div>
        <div class="dist-section-header__title-row">
            <h1 class="dist-section-header__title">{{ title }}</h1>
            <div v-if="$slots.actions" class="dist-section-header__actions">
                <slot name="actions" />
            </div>
        </div>
        <p v-if="lede" class="dist-section-header__lede">{{ lede }}</p>
    </header>
</template>

<script>
export default {
    name: "SectionHeader",
    props: {
        eyebrow: { type: String, default: "" },
        title: { type: String, required: true },
        lede: { type: String, default: "" },
    },
};
</script>

<style scoped>
.dist-section-header {
    margin-bottom: 20px;
}
.dist-section-header__eyebrow {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: var(--tf-fg-4);
    margin-bottom: 6px;
}
.dist-section-header__title-row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 16px;
}
.dist-section-header__title {
    font-family: "Poppins", sans-serif;
    font-size: 22px;
    font-weight: 600;
    color: var(--tf-fg-1);
    margin: 0;
}
.dist-section-header__actions {
    flex-shrink: 0;
}
.dist-section-header__lede {
    font-size: 13px;
    color: var(--tf-fg-3);
    margin: 6px 0 0 0;
    max-width: 720px;
    line-height: 1.5;
}
</style>
